var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1667,
    cy: 18.1667,
    r: 18.1667,
    fill: "#FBD2EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2087 8.92383C22.1765 8.93988 21.1668 9.22803 20.2816 9.75916C19.3963 10.2903 18.6669 11.0456 18.167 11.9488C17.6671 11.0456 16.9377 10.2903 16.0525 9.75916C15.1673 9.22803 14.1576 8.93988 13.1254 8.92383C11.4799 8.99532 9.9296 9.71514 8.81317 10.926C7.69674 12.1369 7.10493 13.7405 7.16704 15.3863C7.16704 19.5544 11.5542 24.1066 15.2337 27.193C16.0552 27.8834 17.0939 28.2619 18.167 28.2619C19.2401 28.2619 20.2788 27.8834 21.1004 27.193C24.7799 24.1066 29.167 19.5544 29.167 15.3863C29.2291 13.7405 28.6373 12.1369 27.5209 10.926C26.4045 9.71514 24.8542 8.99532 23.2087 8.92383ZM19.9225 25.7905C19.4311 26.2043 18.8094 26.4312 18.167 26.4312C17.5247 26.4312 16.903 26.2043 16.4116 25.7905C11.7018 21.8387 9.00037 18.0474 9.00037 15.3863C8.93771 14.2265 9.3362 13.0889 10.109 12.2217C10.8817 11.3545 11.966 10.8281 13.1254 10.7572C14.2847 10.8281 15.369 11.3545 16.1418 12.2217C16.9145 13.0889 17.313 14.2265 17.2504 15.3863C17.2504 15.6294 17.3469 15.8626 17.5189 16.0345C17.6908 16.2064 17.9239 16.303 18.167 16.303C18.4102 16.303 18.6433 16.2064 18.8152 16.0345C18.9871 15.8626 19.0837 15.6294 19.0837 15.3863C19.021 14.2265 19.4195 13.0889 20.1923 12.2217C20.965 11.3545 22.0493 10.8281 23.2087 10.7572C24.3681 10.8281 25.4524 11.3545 26.2251 12.2217C26.9979 13.0889 27.3964 14.2265 27.3337 15.3863C27.3337 18.0474 24.6323 21.8387 19.9225 25.7868V25.7905Z",
    fill: "#071E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(7.16699 7.16699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.140e511f0ceb4837ceb091838ab03d82.svg";
export { ForwardRef as ReactComponent };